/**
 * @return {string}
 */
module.exports = function getHtmlLangValue() {
    const html = document.querySelector("html");

    if (html) {
        return html.getAttribute("lang");
    }

    return '';
}